import React from 'react';
import { RibbonTopBar } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/components';
import { appIcons, getAppStrings, getAppColors } from 'owa-acui-theme';
import type {
    RibbonTabDefinitionBase,
    RibbonTabDefinitionSLR,
    RibbonTabDefinitionMLR,
} from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/components';
import { topBar, topBarContainer } from './CommandRibbonTopBar.scss';
import { observer } from 'owa-mobx-react';

export const CommandRibbonTopBar = observer(function CommandRibbonTopBar({
    extraControlsBeforeTabs,
    extraControlsAfterTabs,
    onTabHeaderClick,
    ribbonTabs,
    selectedTab,
}: {
    extraControlsAfterTabs?: React.ReactNode;
    extraControlsBeforeTabs?: React.ReactNode;
    onTabHeaderClick: (tabId: string) => void;
    ribbonTabs: RibbonTabDefinitionBase[];
    selectedTab: RibbonTabDefinitionSLR | RibbonTabDefinitionMLR;
}) {
    return (
        <div id="TopBar" className={topBar}>
            {extraControlsBeforeTabs}
            <div className={topBarContainer}>
                <RibbonTopBar
                    appColors={getAppColors()}
                    appStrings={getAppStrings()}
                    displayDynamicTabHeaderIndicator={true}
                    onTabHeaderClick={onTabHeaderClick}
                    overflowTabHeaderMenuLauncherIcon={appIcons.tabListOverflowLauncher}
                    ribbonTabs={ribbonTabs}
                    selectedTabId={selectedTab.id}
                    isTabIndicatorRounded={true}
                />
            </div>
            {extraControlsAfterTabs}
        </div>
    );
},
'CommandRibbonTopBar');
